var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportShopifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.5,
    r: 32,
    fill: "#EE741F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8006 17.3775C49.6622 17.3775 50.3606 18.076 50.3606 18.9375V27.3201C50.3606 28.1816 49.6622 28.8801 48.8006 28.8801H40.4181C39.5565 28.8801 38.8581 28.1816 38.8581 27.3201C38.8581 26.4585 39.5565 25.7601 40.4181 25.7601H47.2406V18.9375C47.2406 18.076 47.9391 17.3775 48.8006 17.3775Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0006 18.4559C30.1879 18.4559 28.393 18.8133 26.7186 19.5076C25.0441 20.2019 23.523 21.2195 22.2421 22.5022C21.6334 23.1119 20.6456 23.1126 20.036 22.5038C19.4263 21.895 19.4256 20.9073 20.0344 20.2976C21.605 18.7247 23.4703 17.4769 25.5235 16.6255C27.5768 15.7742 29.7778 15.3359 32.0006 15.3359C34.2234 15.3359 36.4244 15.7742 38.4777 16.6255C40.5305 17.4767 42.3954 18.7241 43.9657 20.2965C43.9654 20.2961 43.9661 20.2969 43.9657 20.2965L49.9021 26.2154C50.5122 26.8237 50.5136 27.8114 49.9053 28.4215C49.297 29.0317 48.3093 29.0331 47.6992 28.4248L41.7615 22.5046L41.7591 22.5022C40.4783 21.2195 38.9571 20.2019 37.2827 19.5076C35.6082 18.8133 33.8133 18.4559 32.0006 18.4559Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6406 37.2045C13.6406 36.3429 14.3391 35.6445 15.2006 35.6445H23.5832C24.4447 35.6445 25.1432 36.3429 25.1432 37.2045C25.1432 38.066 24.4447 38.7645 23.5832 38.7645H16.7606V45.587C16.7606 46.4486 16.0622 47.147 15.2006 47.147C14.3391 47.147 13.6406 46.4486 13.6406 45.587V37.2045Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0959 36.103C14.7042 35.4929 15.692 35.4915 16.3021 36.0998L22.2421 42.0224C23.523 43.3051 25.0441 44.3227 26.7186 45.017C28.393 45.7113 30.1879 46.0686 32.0006 46.0686C33.8133 46.0686 35.6082 45.7113 37.2827 45.017C38.9571 44.3227 40.4783 43.3051 41.7591 42.0224C42.3679 41.4127 43.3556 41.412 43.9653 42.0208C44.5749 42.6295 44.5756 43.6173 43.9669 44.2269C42.3963 45.7998 40.531 47.0477 38.4777 47.899C36.4244 48.7504 34.2234 49.1886 32.0006 49.1886C29.7778 49.1886 27.5768 48.7504 25.5235 47.899C23.4708 47.0479 21.6059 45.8004 20.0355 44.2281C20.0351 44.2277 20.0359 44.2284 20.0355 44.2281L14.0992 38.3092C13.489 37.7009 13.4876 36.7131 14.0959 36.103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportShopifyIcon);
export default __webpack_public_path__ + "static/media/import-shopify-icon.475d739f81c0d6e7a002a191abd9ff7c.svg";
export { ForwardRef as ReactComponent };